module.exports = __webpack_public_path__ + "static/img/indexbg3.33fa3f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexbg3.png
// module id = oVoU
// module chunks = 1